import Column from '@app/components/layout/Column'
import {
  ContentSections,
  ContentSectionType,
} from '@app/components/blocks/contentSection/ContentSection'
import useMediaQuery from '@app/util/useMediaQuery'

export const RegularContentTab = ({
  sections,
}: {
  sections?: ContentSectionType[]
}) => {
  const isMobile = useMediaQuery()
  const largerGap = isMobile ? '2rem' : '3.5rem'
  return (
    <Column gap={largerGap} alignItems="stretch">
      {sections && <ContentSections sections={sections} />}
    </Column>
  )
}
